// extracted by mini-css-extract-plugin
export default {"header":"Dialog_header__PL-4X","content":"Dialog_content__iWx0u","headingActionBar":"Dialog_headingActionBar__uuUky"};